import Login from './views/Login.vue'
import NotFound from './views/404.vue'
import Home from './views/Home.vue'
import userManage from "./views/userManage/userManage.vue";
import adManage from "./views/adManage/adManage.vue";
import logManage from "./views/logManage/logManage.vue";
// import Table from './views/nav1/Table.vue'
// import echarts from './views/charts/echarts.vue'
// import {hasPermission} from './premission'



let routes = [
    {
        path: '/login',
        component: Login,
        name: '',
        hidden: true
    },
    {
        path: '/404',
        component: NotFound,
        name: '',
        hidden: true
    },
    //{ path: '/main', component: Main },
    {
        path: '/',
        component: Home,
        name: 'userManage',
        leaf: true,//只有一个节点
        iconCls: 'fa fa-id-card-o',//图标样式class
        children: [
            { path: '/userManage', component: userManage, name: '用户管理' },
        ]
    },
    {
        path: '/',
        component: Home,
        name: 'adManage',
        leaf: true,//只有一个节点
        iconCls: 'fa fa-id-card-o',//图标样式class
        children: [
            { path: '/adManage', component: adManage, name: '广告管理' },
        ]
    },
    {
        path: '/',
        component: Home,
        name: 'logManage',
        leaf: true,//只有一个节点
        iconCls: 'fa fa-id-card-o',//图标样式class
        children: [
            { path: '/logManage', component: logManage, name: '操作日志' },
        ]
    },
    // {
    //     path: '/',
    //     component: Home,
    //     name: 'orderRoute',
    //     leaf: true,//只有一个节点
    //     iconCls: 'fa fa-id-card-o',//图标样式class
    //     children: [
    //         { path: '/orderRoute', component: orderRoute, name: '路由信息' },
    //     ]
    // },
    // {
    //     path: '/',
    //     component: Home,
    //     name: '财务管理',
    //     leaf:false,//只有一个节点
    //     iconCls: 'fa fa-id-card-o',//图标样式class
    //     children: [
    //         { path: '/orderManagement', component: orderManagement, name: '订单管理' },
    //     ],
    //     // hidden: hasPermission('0','financialManagement')
    //     hidden: sessionStorage.getItem('financialManagement') == 'false'
    //
    // },
    // {
    //     path: '/',
    //     component: Home,
    //     name: '客户管理',
    //     leaf: false,//只有一个节点
    //     iconCls: 'fa fa-id-card-o',//图标样式class
    //     children: [
    //         { path: '/salesmanInfo', component: salesmanInfo, name: '业务员管理' },
    //         { path: '/SendingReceivingInfo', component: SendingReceivingInfo, name: '收发地管理' },
    //         { path: '/customersInfo', component: customersInfo, name: '客户管理' },
    //         { path: '/quotationInfo', component: quotationInfo, name: '报价单管理' },
    //         // { path: '/freightCalculation', component: freightCalculation, name: '运费计算' },
    //     ],
    //     hidden: sessionStorage.getItem('customersInfo') == 'false'
    //
    // },

    // {
    //     path: '/',
    //     component: Home,
    //     name: 'Charts',
    //     leaf: true,
    //     iconCls: 'fa fa-bar-chart',
    //     children: [
    //         { path: '/echarts', component: echarts, name: '图表展示' }
    //     ]
    // },
    {
        path: '*',
        hidden: true,
        redirect: { path: '/404' }
    }
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js